import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import routes from "routes";
import { canAccessRoute, getFirstAccessiblePath } from "utils/permissions";
import NoAccess from "layouts/NoAccess";
import NoWorkspace from "layouts/NoWorkspace";

// `route` is the routes.js entry being rendered; omit it for pages that any
// signed-in admin may open.
const PrivateRoute = ({ children, route }) => {
  const { isLoggedIn, token, permissions, admin, team, channel } = useSelector(
    (state) => state.auth
  );
  const location = useLocation();

  if (!isLoggedIn || !token) {
    return <Navigate to="/authentication/sign-in" state={{ from: location }} replace />;
  }

  // Permissions arrive with sign-in / the /me refresh; wait rather than flash "no access".
  if (!Array.isArray(permissions)) {
    return null;
  }

  if (route && !canAccessRoute(route, permissions, admin)) {
    const fallback = getFirstAccessiblePath(routes, permissions, admin);
    if (fallback && fallback !== location.pathname) {
      return <Navigate to={fallback} replace />;
    }
    return <NoAccess />;
  }

  // Most pages work on one Slack workspace and channel. An organization that has
  // none yet (a platform admin switched to it) can't show them.
  if (route && !route.worksWithoutWorkspace && (!team || !channel)) {
    return <NoWorkspace />;
  }

  return children;
};

export default PrivateRoute;
